// No legacy reducers in this widget.
// This stub satisfies the ws-scripts store.js dynamic require('../reducers').
export default {};
